import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import airportIcon from '@iconify/icons-mdi/airport';
// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
import { useTranslation } from '../../../common/LocalizationProvider';
import { fNumber } from '../../../common/utils/formatNumber';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.info.darker,
  backgroundColor: theme.palette.info.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.info.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.info.dark, 0)} 0%, ${alpha(
    theme.palette.info.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

const handleRemoveDublicateOaci = (oaci) => {
  const newOaci = oaci.filter((elem, pos) => oaci.indexOf(elem) === pos);

  return newOaci.length;
};

AppAeros.propTypes = {
  summary: PropTypes.array
};

export default function AppAeros({ summary }) {
  const t = useTranslation();

  const aeros = handleRemoveDublicateOaci(
    summary.reduce((sum, item) => {
      if (item.aeros !== null) {
        sum = [...sum, ...item.aeros];
      }
      return sum;
    }, [])
  );

  return (
    <RootStyle>
      <IconWrapperStyle>
        <Icon icon={airportIcon} width={24} height={24} />
      </IconWrapperStyle>
      <Typography variant="h3">{fNumber(aeros)}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        {aeros === 1 ? t('DB_Aero') : t('DB_Aeros')}
      </Typography>
    </RootStyle>
  );
}
